import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const ConfirmBlockUser = (props)=>{
const closePopup =() =>{
  props.CancelPopup();
}
const BlockUnblock=()=>{
  props.handleBlock(props.blockUserId,props.blockType);
}

return(
<div>
      <Modal show={props.isConfirm} onHide={props.CancelPopup}
       dialogClassName="small-custom-modal  modal-dialog-centered">
        <Modal.Header closeButton>
        <div className="popupheader">
        <div className="mod-bor-icon" >
       <FontAwesomeIcon icon={faTrash} />
            </div>
            <div className="header">
              <div className="signuup">
               {props.blockType === "block" 
              ? "Block User" 
              : props.blockType === "unblock" 
                ? "Unblock User" 
                : "Exit Group"}
              </div>
              <p className="Stronger"></p>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          <div>
          <p className="fov-text">Do you want to  {props.blockType} {props.blockUserName} ?</p>
          </div>
       
        </Modal.Body>

          <Modal.Footer className="full-w" >
                      <button type="button" className="cancel-btn" onClick={()=>closePopup()}>No</button>
                          <button className="next-btn"  onClick={()=>BlockUnblock()}>Yes</button>
                </Modal.Footer>
      
      </Modal>
      
    </div>
);
  

};
export default ConfirmBlockUser;